import List from "list.js";

// Global settings
const pagesVisible = document.querySelector(".js-page-show")
  ? Number(document.querySelector(".js-page-show").dataset.pageNumber)
  : 3;

// Search filter global
let categoryListGlobalFit;

// Full listing
/////////////////////////////////////////////
const fullListingGrid = document.querySelector("#global-fit-listing--full");

if (fullListingGrid) {
  let options = {
    valueNames: ["oma-files__product-title"],
    listClass: "oma-files__grid--full",
    page: pagesVisible,
  };

  // List Global fit wrapper
  const paginationGlobalFit = document.querySelector(".pagination--full");

  if (
    fullListingGrid.querySelectorAll(".oma-files__product-box").length !== 0
  ) {
    // List Global fit instance
    categoryListGlobalFit = new List("global-fit-listing--full", options);

    categoryListGlobalFit.sort("oma-files__product-title", { order: "asc" });
  } else {
    console.log(fullListingGrid.querySelector(`.${options.listClass}`));
    paginationGlobalFit.style.display = "none";
    fullListingGrid.querySelector(`.${options.listClass}`).style.display =
      "block";
    fullListingGrid.querySelector(`.${options.listClass}`).style.textAlign =
      "center";
    fullListingGrid.querySelector(`.${options.listClass}`).textContent =
      "Files no found";
  }

  // Input search
  const inputSearchFullList = document.querySelector(
    "#global-fit-search--full-list",
  );

  // Pagination button prev
  const paginationGlobalFitPrevButton =
    paginationGlobalFit.querySelector(".pagination__prev");

  // Pagination button next
  const paginationGlobalFitNextButton =
    paginationGlobalFit.querySelector(".pagination__next");

  // Pagination max pages
  let paginationGlobalFitSize = categoryListGlobalFit
    ? categoryListGlobalFit.size() / categoryListGlobalFit.page
    : 1;

  // Pagination current page
  let paginationGlobalFitCurrentIndex = 1;

  // Filter search
  inputSearchFullList.addEventListener("input", (input) => {
    if (categoryListGlobalFit !== undefined) {
      categoryListGlobalFit.search(input.target.value, [
        "oma-files__product-title",
      ]);
    }

    if (
      categoryListGlobalFit !== undefined &&
      categoryListGlobalFit.visibleItems.length === 0
    ) {
      fullListingGrid.querySelector(`.${options.listClass}`).style.display =
        "block";
      fullListingGrid.querySelector(`.${options.listClass}`).style.textAlign =
        "center";
      fullListingGrid.querySelector(`.${options.listClass}`).textContent =
        "Files no found";
    }

    if (
      categoryListGlobalFit !== undefined &&
      input.target.value.length === 0
    ) {
      fullListingGrid
        .querySelector(`.${options.listClass}`)
        .removeAttribute("style");
    }

    if (
      input.target.value.length === 0 &&
      categoryListGlobalFit !== undefined
    ) {
      paginationGlobalFit.style.display = "flex";
    } else {
      paginationGlobalFit.style.display = "none";
    }

    if (input.target.value.length === 0) {
      document.querySelector("#sort-by-az").checked = true;
      paginationGlobalFit.style.display = "flex";
      // document.querySelector("#show-all").click();
      document.querySelector(".oma-files__full-listing").classList.add("show");

      Array.from(document.querySelectorAll(".oma-files__category")).forEach(
        (category) => {
          category.classList.remove("show");
        },
      );
      document.querySelector(".oma-files__category--az").classList.add("show");
    } else {
      document.querySelector("#sort-by-az").checked = false;
      document.querySelector("#global-fit").checked = false;
      document.querySelector("#regular-collections").checked = false;
      // paginationGlobalFit.style.display = "none";

      Array.from(document.querySelectorAll(".oma-files__category")).forEach(
        (category) => {
          category.classList.remove("show");
        },
      );
      document.querySelector(".oma-files__full-listing").classList.add("show");
    }
  });

  // ResetButton
  inputSearchFullList
    .closest(".input-search")
    .querySelector(".js-input__button-reset")
    .addEventListener("click", () => {
      if (categoryListGlobalFit !== undefined) {
        categoryListGlobalFit.search("", ["oma-files__product-title"]);
        paginationGlobalFit.style.display = "flex";
        fullListingGrid
          .querySelector(`.${options.listClass}`)
          .removeAttribute("style");
      }

      inputSearchFullList.value = "";
      document.querySelector("#sort-by-az").checked = true;
    });

  paginationGlobalFit.querySelector(".pagination__number").textContent =
    `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

  // categoryListGlobalFit.show(7, 3);

  paginationGlobalFitNextButton.addEventListener("click", (button) => {
    if (paginationGlobalFitCurrentIndex < Math.ceil(paginationGlobalFitSize)) {
      // Update index
      paginationGlobalFitCurrentIndex++;

      const lastShowPage =
        categoryListGlobalFit.items.length -
        (paginationGlobalFitCurrentIndex - 1) * categoryListGlobalFit.page;

      if (
        paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize)
      ) {
        // Update product list
        categoryListGlobalFit.show(
          (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
          lastShowPage,
        );
      } else {
        // Update product list
        categoryListGlobalFit.show(
          (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
          pagesVisible,
        );
      }

      // Update pagination index
      paginationGlobalFit.querySelector(".pagination__number").textContent =
        `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;
    }

    // Disabled next button
    if (
      paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize) &&
      categoryListGlobalFit.items.length > pagesVisible
    ) {
      button.currentTarget.setAttribute("disabled", "disabled");
    }

    // Enabled prev button
    if (
      paginationGlobalFitCurrentIndex <= Math.ceil(paginationGlobalFitSize) &&
      categoryListGlobalFit.items.length > pagesVisible
    ) {
      paginationGlobalFitPrevButton.removeAttribute("disabled");
    }
  });

  paginationGlobalFitPrevButton.addEventListener("click", (button) => {
    if (paginationGlobalFitCurrentIndex !== 1) {
      // Update index
      paginationGlobalFitCurrentIndex--;

      // Update product list
      categoryListGlobalFit.show(
        (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
        pagesVisible,
      );

      // Update pagination index
      paginationGlobalFit.querySelector(".pagination__number").textContent =
        `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

      // // Enabled next button
      if (
        paginationGlobalFitCurrentIndex !== Math.ceil(paginationGlobalFitSize)
      ) {
        paginationGlobalFitNextButton.removeAttribute("disabled");
      }

      // Disabled prev button
      if (paginationGlobalFitCurrentIndex === 1) {
        button.currentTarget.setAttribute("disabled", "disabled");
      }
    }
  });
}

// Global fit Collections
/////////////////////////////////////////////
const globalFitGrid = document.querySelector("#global-fit-listing--global-fit");

if (globalFitGrid) {
  let options = {
    valueNames: ["oma-files__product-box"],
    listClass: "oma-files__grid--global-fit",
    page: pagesVisible,
  };

  let categoryListGlobalFit = null;

  // List Global fit wrapper
  const paginationGlobalFit = document.querySelector(".pagination--global-fit");

  if (globalFitGrid.querySelectorAll(".oma-files__product-box").length !== 0) {
    // List Global fit instance
    categoryListGlobalFit = new List("global-fit-listing--global-fit", options);

    categoryListGlobalFit.sort("oma-files__product-title", { order: "asc" });
  } else {
    paginationGlobalFit.style.display = "none";

    globalFitGrid.querySelector(`.${options.listClass}`).style.display =
      "block";
    globalFitGrid.querySelector(`.${options.listClass}`).style.textAlign =
      "center";
    globalFitGrid.querySelector(`.${options.listClass}`).textContent =
      "Files no found";
  }

  // Pagination button prev
  const paginationGlobalFitPrevButton =
    paginationGlobalFit.querySelector(".pagination__prev");

  // Pagination button next
  const paginationGlobalFitNextButton =
    paginationGlobalFit.querySelector(".pagination__next");

  // Pagination max pages
  const paginationGlobalFitSize =
    categoryListGlobalFit !== null
      ? categoryListGlobalFit.size() / categoryListGlobalFit.page
      : 1;

  // Pagination current page
  let paginationGlobalFitCurrentIndex = 1;

  paginationGlobalFit.querySelector(".pagination__number").textContent =
    `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

  paginationGlobalFitNextButton.addEventListener("click", (button) => {
    if (paginationGlobalFitCurrentIndex < Math.ceil(paginationGlobalFitSize)) {
      // Update index
      paginationGlobalFitCurrentIndex++;

      const lastShowPage =
        categoryListGlobalFit.items.length -
        (paginationGlobalFitCurrentIndex - 1) * categoryListGlobalFit.page;

      if (
        paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize)
      ) {
        // Update product list
        categoryListGlobalFit.show(
          (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
          lastShowPage,
        );
      } else {
        // Update product list
        categoryListGlobalFit.show(
          (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
          pagesVisible,
        );
      }

      // Update pagination index
      paginationGlobalFit.querySelector(".pagination__number").textContent =
        `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;
    }

    // Disabled next button
    if (
      paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize) &&
      categoryListGlobalFit.items.length > pagesVisible
    ) {
      button.currentTarget.setAttribute("disabled", "disabled");
    }

    // Enabled prev button
    if (
      paginationGlobalFitCurrentIndex <= Math.ceil(paginationGlobalFitSize) &&
      categoryListGlobalFit.items.length > pagesVisible
    ) {
      paginationGlobalFitPrevButton.removeAttribute("disabled");
    }
  });

  paginationGlobalFitPrevButton.addEventListener("click", (button) => {
    if (paginationGlobalFitCurrentIndex !== 1) {
      // Update index
      paginationGlobalFitCurrentIndex--;

      // Update product list
      categoryListGlobalFit.show(
        (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
        pagesVisible,
      );

      // Update pagination index
      paginationGlobalFit.querySelector(".pagination__number").textContent =
        `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

      // // Enabled next button
      if (
        paginationGlobalFitCurrentIndex !== Math.ceil(paginationGlobalFitSize)
      ) {
        paginationGlobalFitNextButton.removeAttribute("disabled");
      }

      // Disabled prev button
      if (paginationGlobalFitCurrentIndex === 1) {
        button.currentTarget.setAttribute("disabled", "disabled");
      }
    }
  });
}

// Regular collections and Wire: a list with pages of its own
/////////////////////////////////////////////
const listWithPagination = (name) => {
  const regularCollectionsGrid = document.querySelector(
    `#global-fit-listing--${name}`,
  );

  if (regularCollectionsGrid) {
    let options = {
      valueNames: ["oma-files__product-box"],
      listClass: `oma-files__grid--${name}`,
      page: pagesVisible,
    };

    let categoryListGlobalFit = null;

    // List Global fit wrapper
    const paginationGlobalFit = document.querySelector(
      `.pagination--${name}`,
    );

    if (
      regularCollectionsGrid.querySelectorAll(".oma-files__product-box")
        .length !== 0
    ) {
      // List Global fit instance
      categoryListGlobalFit = new List(
        `global-fit-listing--${name}`,
        options,
      );

      categoryListGlobalFit.sort("oma-files__product-title", { order: "asc" });
    } else {
      paginationGlobalFit.style.display = "none";

      regularCollectionsGrid.querySelector(
        `.${options.listClass}`,
      ).style.display = "block";
      regularCollectionsGrid.querySelector(
        `.${options.listClass}`,
      ).style.textAlign = "center";
      regularCollectionsGrid.querySelector(`.${options.listClass}`).textContent =
        "Files no found";
    }

    // Pagination button prev
    const paginationGlobalFitPrevButton =
      paginationGlobalFit.querySelector(".pagination__prev");

    // Pagination button next
    const paginationGlobalFitNextButton =
      paginationGlobalFit.querySelector(".pagination__next");

    // Pagination max pages
    const paginationGlobalFitSize =
      categoryListGlobalFit !== null
        ? categoryListGlobalFit.size() / categoryListGlobalFit.page
        : 1;

    // Pagination current page
    let paginationGlobalFitCurrentIndex = 1;

    paginationGlobalFit.querySelector(".pagination__number").textContent =
      `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

    paginationGlobalFitNextButton.addEventListener("click", (button) => {
      if (paginationGlobalFitCurrentIndex < Math.ceil(paginationGlobalFitSize)) {
        // Update index
        paginationGlobalFitCurrentIndex++;

        const lastShowPage =
          categoryListGlobalFit.items.length -
          (paginationGlobalFitCurrentIndex - 1) * categoryListGlobalFit.page;

        if (
          paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize)
        ) {
          // Update product list
          categoryListGlobalFit.show(
            (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
            lastShowPage,
          );
        } else {
          // Update product list
          categoryListGlobalFit.show(
            (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
            pagesVisible,
          );
        }

        // Update pagination index
        paginationGlobalFit.querySelector(".pagination__number").textContent =
          `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;
      }

      // Disabled next button
      if (
        paginationGlobalFitCurrentIndex === Math.ceil(paginationGlobalFitSize) &&
        categoryListGlobalFit.items.length > pagesVisible
      ) {
        button.currentTarget.setAttribute("disabled", "disabled");
      }

      // Enabled prev button
      if (
        paginationGlobalFitCurrentIndex <= Math.ceil(paginationGlobalFitSize) &&
        categoryListGlobalFit.items.length > pagesVisible
      ) {
        paginationGlobalFitPrevButton.removeAttribute("disabled");
      }
    });

    paginationGlobalFitPrevButton.addEventListener("click", (button) => {
      if (paginationGlobalFitCurrentIndex !== 1) {
        // Update index
        paginationGlobalFitCurrentIndex--;

        // Update product list
        categoryListGlobalFit.show(
          (paginationGlobalFitCurrentIndex - 1) * pagesVisible + 1,
          pagesVisible,
        );

        // Update pagination index
        paginationGlobalFit.querySelector(".pagination__number").textContent =
          `${paginationGlobalFitCurrentIndex}/${Math.ceil(paginationGlobalFitSize)}`;

        // // Enabled next button
        if (
          paginationGlobalFitCurrentIndex !== Math.ceil(paginationGlobalFitSize)
        ) {
          paginationGlobalFitNextButton.removeAttribute("disabled");
        }

        // Disabled prev button
        if (paginationGlobalFitCurrentIndex === 1) {
          button.currentTarget.setAttribute("disabled", "disabled");
        }
      }
    });
  }
};

listWithPagination("regular-collections");
listWithPagination("wire");

export { categoryListGlobalFit };
